<div class="center">
    <loading-component></loading-component>
</div>
